<template>
  <div v-if="canShowItemsList" class="bp-page arsenal">
    <PageName pageName="arsenal" />

    <div class="arsenal__layout">
      <ArsenalItemBig :activeItemData="active_item_data" />

      <div class="arsenal__list">
        <ArsenalTabs :activeTab="active_tab" @changeTab="changeTab" />
        <ArsenalFilters :activeFilter="active_filter" @changeFilter="changeFilter" />
        <ArsenalItems
          :listItems="filteredItems"
          :activeItemData="active_item_data"
          scrollClass="arsenal__list__items"
          @changeActiveItem="changeActiveItem"
        />
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/arsenal/styles/arsenal.styl";
import PageName from "@/components/Common/PageName";
import ArsenalItemBig from "./blocks/ArsenalItemBig";
import ArsenalTabs from "./blocks/ArsenalTabs";
import ArsenalFilters from "./blocks/ArsenalFilters";
import ArsenalItems from "./blocks/ArsenalItems";

import ArsenalItemsIds from "./ArsenalItemsIds";
// import BoxesItems from "./BoxesItemsMock";

import { mapGetters } from "vuex";

export default {
  name: "Arsenal",
  components: {
    PageName,
    ArsenalItemBig,
    ArsenalTabs,
    ArsenalFilters,
    ArsenalItems,
  },

  data() {
    return {
      arsenal_items: [],
      arsenal_filtered_items: [],
      active_item_data: null,
      active_tab: "all",
      active_filter: "all",
      items_types: ["regular", "permanent"],
    };
  },

  computed: {
    ...mapGetters("shop", ["getShopList"]),

    canShowItemsList() {
      return this.arsenal_items.length > 0;
    },

    filteredItems() {
      let filtered_items = null;
      let fetched_filter = null;

      // Step 1
      // Filtering items by "fetch" param
      switch (this.active_tab) {
        case "fetched":
          fetched_filter = this.arsenal_items.filter(item => item.fetched);
          break;

        case "no-fetched":
          fetched_filter = this.arsenal_items.filter(item => !item.fetched);
          break;

        default:
          fetched_filter = this.arsenal_items;
          break;
      }

      // Step 2
      // Filtering items by type
      switch (this.active_filter) {
        case "weapon":
          filtered_items = fetched_filter.filter(
            item => !item.reward.item.id.includes("skin_") && !item.reward.item.id.includes("fbs_")
          );
          break;

        case "skin":
          filtered_items = fetched_filter.filter(item => item.reward.item.id.includes("skin_"));
          break;

        case "appearance":
          filtered_items = fetched_filter.filter(item => item.reward.item.id.includes("fbs_"));
          break;

        default:
          filtered_items = fetched_filter;
          break;
      }

      return filtered_items;
    },
  },

  mounted() {
    this.getBoxesData();
    // this.getItemsList(BoxesItems);
  },

  methods: {
    getBoxesData() {
      if (this.getShopList) {
        this.getItemsList(this.getShopList);
      } else {
        this.$store.dispatch("shop/getShopList").then(() => {
          this.getItemsList(this.getShopList);
        });
      }
    },

    getItemsList(items_array) {
      items_array.forEach(box => {
        box.rewards.forEach(box_item => {
          if (
            ArsenalItemsIds.includes(box_item.reward.item.id) &&
            this.isUniqueItem(box_item.reward.item.id) &&
            this.isValidType(box_item.reward.item)
          ) {
            this.arsenal_items.push(box_item);
          }
        });
      });

      this.active_item_data = this.arsenal_items[0];

      this.$store.dispatch("shop/getShopList").then(() => {
        this.show_page = true;
      });
    },

    isUniqueItem(item_id) {
      return this.arsenal_items.every(item => item.reward.item.id !== item_id);
    },

    isValidType(item) {
      return !!(item.permanent || item.regular);
    },

    changeActiveItem(item) {
      this.active_item_data = item;
    },

    changeTab(tab) {
      this.active_tab = tab;
      this.active_item_data = this.filteredItems[0];
    },

    changeFilter(filter) {
      this.active_filter = filter;
      this.active_item_data = this.filteredItems[0];
    },
  },
};
</script>
